const lang = {
    "Kep": "КЭП",
    "KepNotLinked": "ваша КЭП ещё не привязана к аккаунту. Войдите обычным способом — и мы привяжем её.",
    "KepNewAccount": "Нет аккаунта? Зарегистрироваться",
    "KepLinked": "КЭП привязана к аккаунту",
    "KepLinkFailed": "Не удалось привязать КЭП. Войдите через КЭП ещё раз — и мы её привяжем",
    "KepFile": "Файловый ключ",
    "ErrorKepLogin": "Не удалось войти по КЭП",
    "EnterWidth": "Войти через:",
    "Registration": "Зарегистрироваться",
    "enter": "Войти",
    "EntrWidthEmailOrPhone": "Войти с помощью почты или телефона",
    "login": "Авторизация",
    "NoAkkGoReg": "Зарегистрируйтесь",
    "Password": "Пароль",
    "Name": "Имя",
    "LastName": "Фамилия",
    "Phone": "Для регистрации введите номер телефона",
    "Email": "Почта",
    "RepeatPassword": "Повторить пароль",
    "Сancel": "Отмена",
    "Save": "Сохранить",
    "Language": "Язык",
    "ConfirmThisMail": "Ваш e-mail подтвержден",
    "Saved": "Сохранено",
    "Error": "Ошибка",
    "FillInAllTheFields": "Заполните все поля",
    "Next": "Далее",
    "MinPassLength": "Минимальная длина пароля 4 символов",
    "ForgotYourPassword": "Забыли пароль",
    "RestorePassword": "Пожалуйста, установите новый пароль.",
    "UserMustBeRegistered": "Пользователь должен быть зарегистрирован",
    "Confirm": "Подтвердить",
    "WrongFormat": "Неверный формат",
    "WrongPassword": "Неверный пароль",
    "WrongLoginOrPassword": "Неверный логин или пароль",
    "PhoneAlreadyRegistered": "Телефон уже зарегистрирован",
    "EmailAlreadyRegistered": "Почта уже зарегистрирована",
    "FillInTheFieldsCorrectly": "Корректно заполните поля",
    "ThisAccountDoesNotExist": "Данный аккаунт не существует",
    "LinkIsNotValid": "Ссылка не действительна",
    "AMessageHasBeenSentToTheSpecifiedLogin": "На указанный логин отправлено сообщение",
    "IncorrectCaptcha": "Неправильная капча",
    "CaptchaIsNotValid": "Капча больше недействительна",
    "EnterCaptcha": "Введите капчу",
    "EnterSMS": "Введите код из СМС",
    "SMSCodeIsNoLongerValid": "СМС код уже не действителен",
    "SMSCodeIsIncorrect": "СМС код неверный",
    "MailNotVerifiedLinkTimedOut": "Почта не подтверждена, истекло время ссылки",
    "DemoLogin": "Демо вход",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "Вы действительно хотите войти в демонстрационную версию для ознакомления?",
    "FillInAdditionalInformation": "Заполнить дополнительную информацию",
    "ToCompleteRegistration": "Для завершения регистрации",
    "LinkThirdPartyServices": "Привязать сторонние сервисы",
    "Complete": "Завершить",
    "AccountAlreadyLinked": "Аккаунт уже привязан",
    "AccountNotRegistered": "Аккаунт не зарегистрирован",
    "NotMyNumber": "Не мой номер",
    "Back": "Назад",
    "numberOfAttemptsToCheckAuth": "Количество попыток для входа:",
    "InvalidPassNumberOfAttemptsToCheckAuth": "Неверный пароль, количество попыток для входа:",
    "TryAgainAfterMinute": "Повторите попытку через 2 минуты",
    "Help": "Техподдержка",
    "y": "Да",
    "n": "Нет",
    "doYouConfirmEmail": "Вы действительно хотите изменить вашу электронную почту?",
    "success": "Успешно",
    "goToAutorize": "Перейти к авторизации",
    "UserEmailAlreadyExists": "Пользователь с такой почтой уже существует",
    "UserPhoneAlreadyExists": "Пользователь с таким телефоном уже существует",
    "TermOfUse": "Условия использования",
    "PrivacyPolicy": "Политика конфиденциальности",
    "accountNotRegistered": "аккаунт не зарегистрирован",
    "wantToReg": "Желаете зарегистрироваться?",
    "weSuccessChangeYouEmail": "Мы успешно изменили ваш адрес электронной почты",
    "youCanCloseThisWindow": "Вы можете закрыть это окно",
    "countryConfirm": "Подтверждение страны",
    "EmailAlreadyTied": "Почта уже привязана к другому аккаунту",
    "areYourCountry": "это ваша страна?",
    "EmergencyEntrance": "Старая авторизация",
    "enterCorrectNumber": "Введите номер в международном формате",
    "thisPhoneRegister": "Такой номер телефона уже зарегистрирован в системе",
    "wantUsePhoneForAuth": "Желаете авторизироваться используя этот номер телефона?",
    "ok": "Ок",
    "regAgree": "Регистрируя аккаунт, я принимаю",
    "wantBind": "Хотите войти в аккаунт и привязать сервис",
    "bind": "Привязать",
    "yoursMailBinded": "Ваша почта указана в существующем аккаунте",
    "wantUsePhoneAndBind": "уже зарегистрирован в системе",
    "notGetDataFromApple": "Не удалось получить данные от Apple",
    "ErrorAppleLogin": "Ошибка при авторизации через Apple",
    "ErrorGoogleLogin": "Ошибка при авторизации через Google",
    "ErrorTelegramLogin": "Ошибка при авторизации через Telegram",
    "ErrorFacebookLogin": "Ошибка при авторизации через Facebook",
    "EMailOrPhone": "Введите корректный телефон или почту",
    "withoutName": "Без имени",
    "goToCabinet": "В кабинет",
    "Logout": "Завершить сеанс",
    "creationDate": "Дата создания",
    "preparingCompany1": "Создаем вашу компанию, пожалуйста, дайте нам минутку...",
    "preparingCompany2": "Готовим интерфейс для управления товарами и услугами...",
    "preparingCompany3": "Работаем над удобным учетом финансов...",
    "preparingCompany4": "Выполняем финальные настройки, почти готово...",
    "companyBlocked": "Эта компания неактивна",
    "youBlockedInComp": "Пользователь не активен, вход невозможен",
    "loginTitle": "Все, что нужно бизнесу — в одном месте",
    "loginDescr": "Автоматизация для магазинов, кафе, служб доставки, ресторанов, складов, производства или предоставления услуг",
    "NoAkkGoRegText": "Нет аккаунта?",
    "LoginPlaceholder": "Укажите необходимые данные",
    "loginText": "Уже есть учетная запись?",
    "and": "и",
    "AcceptTheTerms": "Примите политику конфиденциальности и условия использования",
    "CountryPhoneFormat": "Если это не ваша страна, проверьте правильность ввода международного формата вашего номера телефона",
    "SaveNewPassword": "Сохранить новый пароль"
}

export default function() {
    return lang;
}